// SPDX-License-Identifier: MIT
// Composes Plan 1's pure HydrationStores seams from the real desktop stores. This is
// the only place the hydration touches Tauri-backed I/O; the orchestration logic
// stays in Plan 1's hydrateLocalStores (unit-tested with fakes).
import type { HydrationStores } from './hydrate-stores';
import type { GenesisBackendFile } from './genesis-state';
import { upsertProjectFields } from './desktop-data-bridge';
import { saveSessions } from './session-store';
import { writeProjectEnv } from './desktop-delivery';
import { setSyncMapEntry, appendVersionsDedup } from './continuity-stores';

export function realHydrationStores(): HydrationStores {
  return {
    upsertProjectFields: (localId, fields, localDir) => upsertProjectFields(localId, fields, localDir),
    appendVersions: (rows) => appendVersionsDedup(rows).then(() => undefined),
    saveSessions: (dir, sessions) => saveSessions(dir, sessions),
    setSyncMapEntry: (localId, cloudId) => setSyncMapEntry(localId, cloudId),
    writeEnv: (dir, backend: GenesisBackendFile) => writeProjectEnv(dir, backend.url, backend.anon_key),
  };
}
